module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av0407-290bf86c4cce85d635d801fa9e65100b.jpg";